import { useEffect } from "react";

interface SEOHeadProps {
  title?: string;
  description?: string;
  canonicalUrl?: string;
  ogImage?: string;
  noIndex?: boolean;
}

const SEOHead = ({
  title = "Entrelaces Psicologia | Psicóloga em Casa Forte, Recife",
  description = "Psicoterapia para mulheres em Recife. Atendimento online ou presencial com sigilo e acolhimento. Agende sua consulta particular.",
  canonicalUrl,
  ogImage = "/og-image.jpg",
  noIndex = false,
}: SEOHeadProps) => {
  useEffect(() => {
    // Update title
    document.title = title;

    // Helper to update or create meta tag
    const updateMeta = (name: string, content: string, isProperty = false) => {
      const attribute = isProperty ? "property" : "name";
      let meta = document.querySelector(`meta[${attribute}="${name}"]`);
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute(attribute, name);
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", content);
    };

    // Update meta tags
    updateMeta("description", description);
    updateMeta("og:title", title, true);
    updateMeta("og:description", description, true);
    updateMeta("og:image", ogImage, true);
    updateMeta("twitter:title", title);
    updateMeta("twitter:description", description);

    // Handle robots meta
    if (noIndex) {
      updateMeta("robots", "noindex, nofollow");
    } else {
      const robotsMeta = document.querySelector('meta[name="robots"]');
      if (robotsMeta) {
        robotsMeta.setAttribute("content", "index, follow");
      }
    }

    // Handle canonical URL
    if (canonicalUrl) {
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonicalUrl);
    }

    // Cleanup function to reset to defaults when component unmounts
    return () => {
      document.title = "Entrelaces Psicologia | Psicóloga em Casa Forte, Recife";
    };
  }, [title, description, canonicalUrl, ogImage, noIndex]);

  return null;
};

export default SEOHead;
